module.exports = __webpack_public_path__ + "static/media/CalViewIcon.df3d6323.svg";